// ----------------------------- Debounce

// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.

function debounce( func, wait, immediate ) {
    let timeout;
    return function () {
        let context = this, args = arguments;
        let later = function () {
            timeout = null;
            if ( !immediate ) func.apply( context, args );
        };
        let callNow = immediate && !timeout;
        clearTimeout( timeout );
        timeout = setTimeout( later, wait );
        if ( callNow ) func.apply( context, args );
    };
}

// ----------------------- Gallery

function galleriesInit() {

    let galleries = document.querySelectorAll( '.m__image-gallery .gallery' );

    for ( let i = 0; i < galleries.length; i++ ) {
        let gallery = galleries[ i ],
            cells = gallery.querySelectorAll( '.cell' );

        // Set caption sizes and add click event to image.
        for ( let i = 0; i < cells.length; i++ ) {
            let cell = cells[ i ],
                image = cell.querySelector( 'img.size-xl' ),
                caption = cell.querySelector( '.caption' );

            if (caption) {
                caption.style.width = image.offsetWidth + 'px';
            }
        }

        // Initiate flickity
        let flkty = new Flickity( gallery, {
            // options
            contain: true,
            freeScroll: true,
            prevNextButtons: false,
            pageDots: false,
            wrapAround: true
        } );
    }
}

// ----------------------- Lightbox

function initLightboxes() {

    // Show
    let body = document.querySelector('body');
    let galleries = document.querySelectorAll( '.gallery' );

    function showLightBoxImage() {
        document.addEventListener('touchstart', handleTouchStart, false);
        document.addEventListener('touchmove', handleTouchMove, false);

        let data = this.getAttribute( 'data-id' );
        let image = document.querySelector( '.c__lightbox .image[data-id="' + data + '"]' );

        if (image) {
            body.style.overflow = 'hidden';
            image.classList.add( 'active' );
            image.parentElement.parentElement.classList.add('opened');
        }
    }

    for ( let i = 0; i < galleries.length; i++ ) {
        let gallery = galleries[ i ],
            cells = gallery.querySelectorAll( '.cell' );
        for ( let i = 0; i < cells.length; i++ ) {
            let cell = cells[ i ];
            cell.querySelector( '.button' ).addEventListener( 'click', showLightBoxImage );
        }
    }

    // Hide
    let lightboxes = document.querySelectorAll( '.c__lightbox .image' );

    for ( let i = 0; i < lightboxes.length; i++ ) {
        lightboxes[ i ].addEventListener( 'click', hideLightBoxImage );
    }

    function hideLightBoxImage(event) {
        const isPinterestImage = event.target.classList.contains('pinterest-image');

        if (!isPinterestImage) {
            document.removeEventListener('touchstart', handleTouchStart, false);
            document.removeEventListener('touchmove', handleTouchMove, false);

            body.style.overflow = 'initial';
            this.classList.remove( 'active' );
            this.parentElement.parentElement.classList.remove('opened');
        }
    }

    function getImageActive() {
        return document.querySelector('.c__lightbox .image.active');
    }

    function showPrevBoxImage() {
        let activeImage = getImageActive();
        let prevImage = activeImage.previousElementSibling;

        if (!prevImage) {
            prevImage = activeImage.parentElement.lastElementChild;
        }

        prevImage.classList.add('active');
        activeImage.classList.remove('active');
    }

    function showNextBoxImage() {
        let activeImage = getImageActive();
        let nextImage = activeImage.nextElementSibling;

        if (!nextImage) {
            nextImage = activeImage.parentElement.firstElementChild;
        }

        nextImage.classList.add('active');
        activeImage.classList.remove('active');
    }

    // Swipe
    let xDown = null;
    let yDown = null;

    function handleTouchStart(evt) {
        xDown = evt.touches[0].clientX;
        yDown = evt.touches[0].clientY;
    }

    function handleTouchMove(evt) {
        if (!xDown || !yDown) return;

        let xUp = evt.touches[0].clientX;
        let yUp = evt.touches[0].clientY;

        let xDiff = xDown - xUp;
        let yDiff = yDown - yUp;

        if (Math.abs(xDiff) > Math.abs(yDiff)) {
            if (xDiff > 0) {
                // Left swipe
                showNextBoxImage();
            }
            else {
                // Right swipe
                showPrevBoxImage();
            }
        }

        // Reset values
        xDown = null;
        yDown = null;
    }

    // Controls
    const prevButtons = document.querySelectorAll('.c__lightbox .controls .prev');
    const nextButtons = document.querySelectorAll('.c__lightbox .controls .next');

    function prevImageButton(event) {
        event.preventDefault();
        showPrevBoxImage();
    }

    function nextImageButton(event) {
        event.preventDefault();
        showNextBoxImage();
    }

    for (let i=0; i < prevButtons.length; i++) {
        prevButtons[i].addEventListener('click', prevImageButton);
    }

    for (let i=0; i < nextButtons.length; i++) {
        nextButtons[i].addEventListener('click', nextImageButton);
    }
}

// ----------------------- Isotope gallery

function initIsotope() {
    let galleries = document.querySelectorAll( '.m__isotope-gallery .gallery' );

    for ( let i = 0; i < galleries.length; i++ ) {
        let elem = galleries[ i ];
        let iso = new Isotope( elem, {
            // options
            itemSelector: '.cell',
        } );
    }

}

// ----------------------- Images

function imagesInit() {
    let images = document.querySelectorAll( '.e__image' );

    for ( let i = 0; i < images.length; i++ ) {
        let imageHolder = images[ i ],
            image = imageHolder.querySelector( 'img' );
        if ( image ) {
            if ( imageHolder.classList.contains( 'feature' ) ) {
                image.style.height = image.offsetWidth / ( 9 / 10 ) + 'px';
            } else if ( imageHolder.classList.contains( 'promo' ) ) {
                image.style.height = image.offsetWidth / ( 11 / 15 ) + 'px';
            } else if ( imageHolder.classList.contains( 'regular' ) ) {
                image.style.height = image.offsetWidth / ( 10 / 14 ) + 'px';
            } else if ( imageHolder.classList.contains( 'square' ) ) {
                image.style.height = image.offsetWidth + 'px';
            }
        }
    }

    let featureRelatedContent = document.querySelector( '.m__related-content.feature' );

    if ( featureRelatedContent ) {
        let firstImageHolder = featureRelatedContent.querySelector( '.e__image' );
        if ( firstImageHolder ) {
            let firstImage = firstImageHolder.querySelector( 'img' );
            if ( firstImage ) {
                firstImage.style.height = firstImage.offsetWidth / ( 9 / 10 ) + 'px'; // feature
            }
        }
    }
}

function imagesInitCustom( $imagelist ){

    let images = $imagelist;

    for ( let i = 0; i < images.length; i++ ) {
        let imageHolder = images[ i ],
            image = imageHolder.querySelector( 'img' );
        if ( image ) {
            if ( imageHolder.classList.contains( 'feature' ) ) {
                image.style.height = image.offsetWidth / ( 9 / 10 ) + 'px';
            } else if ( imageHolder.classList.contains( 'promo' ) ) {
                image.style.height = image.offsetWidth / ( 11 / 15 ) + 'px';
            } else if ( imageHolder.classList.contains( 'regular' ) ) {
                image.style.height = image.offsetWidth / ( 10 / 14 ) + 'px';
            } else if ( imageHolder.classList.contains( 'square' ) ) {
                image.style.height = image.offsetWidth + 'px';
            }
        }
    }
}


// ----------------------- Navigation

function navigationInit() {

    // Open menu and search panels
    let openMenu = document.querySelector( '.open-menu' ),
        closeMenu = document.querySelector( '.close-menu' ),
        backMenu = document.querySelector( '.back-menu' ),
        menu = document.querySelector( '.menu-panel' ),
        openSearch = document.querySelector( '.open-search' ),
        closeSearch = document.querySelector( '.close-search' ),
        search = document.querySelector( '.search-panel' ),
        body = document.querySelector( '.m__navigation--body' ),
        footer = document.querySelector( '.m__navigation--footer' ),
        accountToggle = document.querySelector( '.account-toggle' );

    function toggleAccountMenu(event) {
        event.preventDefault();

        const targetElement = document.querySelector(event.currentTarget.hash);

        if (targetElement) {
            targetElement.classList.toggle('show');
        }
    }

    if (accountToggle) {
        accountToggle.addEventListener('click', toggleAccountMenu);
    }

    function openTheMenu() {
        closeTheSearch();
        // Buttons
        openMenu.classList.remove( 'active' );
        closeMenu.classList.add( 'active' );
        backMenu.classList.remove( 'active' );
        // Structure
        body.classList.add( 'active' );
        footer.classList.add( 'active' );
        // Content
        menu.classList.add( 'active' );
    }

    function closeTheMenu() {
        // Buttons
        openMenu.classList.add( 'active' );
        closeMenu.classList.remove( 'active' );
        backMenu.classList.remove( 'active' );
        // Structure
        body.classList.remove( 'active' );
        footer.classList.remove( 'active' );
        // Content
        menu.classList.remove( 'active' );
        relatedPosts.classList.remove( 'active' );
        resetMenuItems();
    }

    openMenu.addEventListener( 'click', openTheMenu );
    closeMenu.addEventListener( 'click', closeTheMenu );

    function openTheSearch() {
        closeTheMenu();
        // Buttons
        openSearch.classList.remove( 'active' );
        closeSearch.classList.add( 'active' );
        //Structure
        body.classList.add( 'active' );
        footer.classList.remove( 'active' );
        footer.style.textAlign = 'left';
        // Content
        search.classList.add( 'active' );
    }

    function closeTheSearch() {
        // Buttons
        openSearch.classList.add( 'active' );
        closeSearch.classList.remove( 'active' );
        //Structure
        body.classList.remove( 'active' );
        footer.style.textAlign = 'right';
        // Content
        search.classList.remove( 'active' );
    }

    openSearch.addEventListener( 'click', openTheSearch );
    closeSearch.addEventListener( 'click', closeTheSearch );

    // Show a sub-menu

    let parents = document.querySelectorAll( '.m__navigation .menu-item-has-children' ),
        subMenus = document.querySelectorAll( '.m__navigation .sub-menu' ),
        relatedPosts = document.querySelector( '.m__navigation .posts-panel' );

    // Show the sub menu item for the link we clicked
    function showSubMenu() {
        // Buttons
        openSearch.classList.remove( 'active' );
        backMenu.classList.add( 'active' );
        footer.classList.add( 'sub-menu-showing' );
        //Content
        let target = this.querySelector( '.sub-menu' );
        let currentSubMenu = document.querySelector( '.m__navigation .sub-menu.active' );
        // If there is another sub-menu open and it is not the target submenu
        // from this event then close it after the target has been opened.
        if ( currentSubMenu && !target.classList.contains( 'active' ) ) {
            currentSubMenu.style.zIndex = -100;
            setTimeout( function () {
                currentSubMenu.classList.remove( 'active' );
                currentSubMenu.style.zIndex = -1;
            }, 500 );
        }
        target.classList.add( 'active' );
        relatedPosts.classList.add( 'active' );
        let relatedPostsImages = document.querySelectorAll( '.m__navigation .posts-panel .e__image' );
        imagesInitCustom( relatedPostsImages );
    }

    for ( let i = 0; i < parents.length; i++ ) {
        let parent = parents[ i ];
        parent.addEventListener( 'click', showSubMenu );
        parent.querySelector( 'a' ).addEventListener( 'click', function ( event ) {
            event.preventDefault();
        } );
    }

    // Reset the menu once the backMenu button is clicked
    function resetMenuItems() {
        // Buttons
        openSearch.classList.add( 'active' );
        backMenu.classList.remove( 'active' );
        footer.classList.remove( 'sub-menu-showing' );
        // Content
        for ( let i = 0; i < subMenus.length; i++ ) {
            subMenus[ i ].classList.remove( 'active' );
        }
        relatedPosts.classList.remove( 'active' );
    }

    backMenu.addEventListener( 'click', resetMenuItems );

}

// ----------------------- Location
function locationInit() {
    const locationsList = document.querySelectorAll('.location-list');

    function toggleChildren(event) {
        event.preventDefault();
        event.currentTarget.classList.toggle('collapsed');
    }

    if (locationsList) {
        for (let i=0; i < locationsList.length; i++) {
            const location = locationsList[i];
            const linksWithChildren = location.querySelectorAll('a.has-children');

            for (let j=0; j < linksWithChildren.length; j++) {
                const link = linksWithChildren[j];

                link.classList.add('collapsed');
                link.addEventListener('click', toggleChildren);
            }
        }
    }
}

// ----------------------- Profile image sorting
class ImageSorting {
    constructor(options={}) {
        this.body = document.querySelector('body');
        this.panel = document.querySelector('.m__sort-images-panel');
        this.panelImagesContainer = this.panel.querySelector('.images-container');
        this.submitButton = document.querySelector('.um-form input[type="submit"]');
        this.fieldContainers = {
            order: Array.from(document.querySelectorAll('div[class*="um-field-brand_gallery_order"]')),
            images: Array.from(document.querySelectorAll('div[class*="um-field-brand_gallery_image"]')),
            captions: Array.from(document.querySelectorAll('div[class*="um-field-brand_gallery_caption"]')),
        };

        this.addListeners();
    }

    addListeners() {
        document.querySelector('.sort-images').addEventListener('click', this.showPanel.bind(this));

        this.panel.querySelector('button.close').addEventListener('click', this.hidePanel.bind(this));
        this.panel.querySelector('button.save').addEventListener('click', this.saveOrder.bind(this));

        this.panelImagesContainer.addEventListener('dragover', this.dragInsideParentOver);
    }

    hideOrderFields() {
        this.fieldContainers.order.forEach(container => { container.style.display = "none"; });
    }

    populateOrderFields() {
        this.fieldContainers.order.forEach((container, index) => {
            const field = container.querySelector('input');

            if (!field.value) {
                field.value = `${index}`;
            }
        });
    }

    sortOrderFields() {
        this.fieldContainers.order.sort((a, b) => {
            const aValue = parseInt(a.querySelector('input').value) || 0;
            const bValue = parseInt(b.querySelector('input').value) || 0;

            return aValue > bValue ? 1 : bValue > aValue ? -1 : 0;
        });
    }

    sortFieldContainers() {
        const imageList = [];
        const captionList = [];

        this.sortOrderFields();

        this.fieldContainers.order.forEach(orderField => {
            const orderKey = orderField.getAttribute('data-key');
            const imageKey = orderKey.replace('order', 'image');
            const captionKey = orderKey.replace('order', 'caption');

            imageList.push(this.fieldContainers.images.find(item => item.getAttribute('data-key') === imageKey));
            captionList.push(this.fieldContainers.captions.find(item => item.getAttribute('data-key') === captionKey));
        });

        this.fieldContainers.images = imageList;
        this.fieldContainers.captions = captionList;
    }

    sortFields() {
        const fieldsContainer = document.querySelector('.um-row.gallery-image-fields');
        let sortedFieldsContainer = fieldsContainer.querySelector('.sorted-fields');

        if (!sortedFieldsContainer) {
            sortedFieldsContainer = document.createElement('div');
            sortedFieldsContainer.classList.add('sorted-fields');
            fieldsContainer.appendChild(sortedFieldsContainer);
        }

        this.hideOrderFields();
        this.populateOrderFields();
        this.sortFieldContainers();

        this.fieldContainers.order.forEach((orderContainer, index) => {
            const orderKey = orderContainer.getAttribute('data-key');
            const imageKey = orderKey.replace('order', 'image');
            const captionKey = orderKey.replace('order', 'caption');
            const imageContainer = this.fieldContainers.images.find(item => item.getAttribute('data-key') === imageKey);
            const captionContainer = this.fieldContainers.captions.find(item => item.getAttribute('data-key') === captionKey);

            sortedFieldsContainer.appendChild(orderContainer);
            sortedFieldsContainer.appendChild(imageContainer);
            sortedFieldsContainer.appendChild(captionContainer);

            orderContainer.querySelector('label').innerText = `Gallery Order ${index + 1}`;
            imageContainer.querySelector('label').innerText = `Gallery Image ${index + 1}`;
            captionContainer.querySelector('label').innerText = `Gallery Caption ${index + 1}`;
        });
    }

    showPanel(event) {
        event.preventDefault();

        this.panel.classList.remove('collapsed');
        this.body.classList.add('sort-panel-open');
    }

    hidePanel() {
        this.panel.classList.add('collapsed');
        this.body.classList.remove('sort-panel-open');

        this.resetPanelImagesOrder();
    }

    addPanelImages() {
        this.fieldContainers.images.forEach(container => {
            const previewContainer = container.querySelector('.um-single-image-preview');
            const previewSrc = previewContainer.querySelector('img').getAttribute('src');

            if (previewSrc) {
                const imageElement = document.createElement('img');
                const imageKey = previewContainer.getAttribute('data-key');
                const orderKey = imageKey.replace('image', 'order');
                const orderField = this.fieldContainers.order.find(item => item.getAttribute('data-key') === orderKey);
                const sortOrder = orderField.querySelector('input').value;

                imageElement.classList.add('draggable');
                imageElement.setAttribute('draggable', 'true');
                imageElement.setAttribute('data-image-key', imageKey);
                imageElement.setAttribute('data-order-key', orderKey);
                imageElement.setAttribute('data-sort-order', sortOrder);
                imageElement.setAttribute('src', previewContainer.querySelector('img').getAttribute('src'));

                imageElement.addEventListener('drag', this.dragElement);
                imageElement.addEventListener('dragend', this.dragElementEnd);

                this.panelImagesContainer.appendChild(imageElement);
            }
        });
    }

    resetPanelImagesOrder() {
        const imageList = Array.from(this.panelImagesContainer.querySelectorAll('img'));

        imageList.sort((a, b) => {
            const aValue = parseInt(a.getAttribute('data-sort-order'));
            const bValue = parseInt(b.getAttribute('data-sort-order'));

            return aValue > bValue ? 1 : bValue > aValue ? -1 : 0;
        });

        imageList.forEach(image => {
            this.panelImagesContainer.appendChild(image);
        });
    }

    saveOrder(event) {
        event.currentTarget.setAttribute('disabled', 'disabled');

        this.panelImagesContainer.querySelectorAll('img').forEach((image, index) => {
            const orderKey = image.getAttribute('data-order-key');
            const orderContainer = this.fieldContainers.order.find(item => item.getAttribute('data-key') === orderKey);
            const field = orderContainer.querySelector('input');

            field.value = `${index}`;
        });

        this.submitButton.click();
    }

    dragElement(event) {
        const x = event.clientX;
        const y = event.clientY;
        const selectedItem = event.currentTarget;
        const parent = selectedItem.parentElement;
        let swapItem = document.elementFromPoint(x, y) === null ? selectedItem : document.elementFromPoint(x, y);

        selectedItem.classList.add('drag-active');
        event.dataTransfer.effectAllowed = 'move';

        if (parent === swapItem.parentNode) {
            swapItem = swapItem !== selectedItem.nextSibling ? swapItem : swapItem.nextSibling;
            parent.insertBefore(selectedItem, swapItem);
        }
    }

    dragElementEnd(event) {
        event.target.classList.remove('drag-active');
    }

    dragInsideParentOver(event) {
        event.preventDefault();
        event.dataTransfer.dropEffect = 'move';
    }

    init() {
        this.sortFields();
        this.addPanelImages();
    }
}

function sortImagesInit() {
    const profileEditing = document.querySelector('.um-profile.um-editing');

    if (profileEditing) {
        new ImageSorting().init();
    }
}

// Run functions

// On document load
document.addEventListener( 'DOMContentLoaded', function () {
    navigationInit();
    imagesInit();
    initLightboxes();
    locationInit();
    sortImagesInit();
} );

// On window load
window.onload = function() {
    galleriesInit();
    initIsotope();
};

// On window resize
window.addEventListener( 'resize', imagesInit );

// On Search and filter Ajax finish
jQuery( document ).on( "sf:ajaxfinish", ".searchandfilter", function () {
    imagesInit();
} );
